import React from "react";
import { useNavigate } from "react-router-dom";

const Breadcrumbs = ({ items }) => {
  const navigate = useNavigate();

  return (
    <nav className="flex items-center gap-2 text-sm mb-6">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="text-gray-400"
            >
              <polyline points="9 18 15 12 9 6" />
            </svg>
          )}
          {item.path ? (
            <button
              onClick={() => navigate(item.path)}
              className="text-gray-500 hover:text-green-500 font-semibold transition-colors"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-gray-900 font-bold">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
